import { configureStore } from '@reduxjs/toolkit'
import panierReducer from './panierReducer';

export default configureStore({
  reducer: {
    panier: panierReducer
  }
})